import { render, staticRenderFns } from "./EditSumsPanel.vue?vue&type=template&id=4e8c1abf"
import script from "./EditSumsPanel.vue?vue&type=script&lang=js"
export * from "./EditSumsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports